<template>
  <div
    :class="mainStyle"
    :style="{ 'background-image': 'url(' + backgroundContent + ')' }"
  >
    <div :class="$style.mainContent">
      <Logo />

      <slot />

      <h2>The kiosk <span>does not</span> accept cash</h2>
    </div>
  </div>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import KioskLayout from '@/layouts/KioskLayout';
import Logo from '@/components/Logo';
import background from '@/assets/img/splash-kiosk.jpg';
import { ROUTES_WITHOUT_HEADER } from '@/apps/kiosk/constants';


@Component({
  components: {
    Logo,
    KioskLayout,
  },
})
/* Layout for the main screens with logo and bg */
export default class KioskSplashLayout extends Vue {
  get backgroundContent() {
    return background;
  }

  get mainStyle() {
    const styles = [
      this.$style.kioskMain,
    ];

    if (ROUTES_WITHOUT_HEADER.includes(this.$router.currentRoute.name)) {
      styles.push(this.$style.kioskHeadless);
    }

    return styles;
  }
}
</script>

<style lang="scss" module>
@import '@/style/variables.scss';

.kioskMain {
  height: calc(100vh - #{$kioskHeaderHeight});
  min-height: calc(1920px - #{$kioskHeaderHeight});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 373px 100px 210px;
  position: relative;

  img {
    width: 500px;
  }
  h2 {
    color: $white;
    font-size: 36px;
    line-height: 44px;
    font-weight: 300;
    text-transform: uppercase;
    span {
      font-weight: 700;
      display: inline-block;
      padding-bottom: 12px;
      border-bottom: 6px solid $green-color;
    }
  }
}

.kioskHeadless {
  height: 100vh;
  min-height: 1920px;
}
.mainContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/layouts/KioskSplashLayout.vue